import { injectable, inject } from 'inversify';
import type { FinancialReportDTO, IReportRepository } from '@/domain/repositories/IReportRepository';
import { TYPES } from '@/di/tokens';

@injectable()
export class GetFinancialReportAction {
  constructor(
    @inject(TYPES.IReportRepository) private reportRepository: IReportRepository
  ) {}

  async execute(): Promise<FinancialReportDTO> {
    return this.reportRepository.getFinancialReport();
  }
}
